import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../Auth Utility/AuthContext';
import { CartContext} from '../Cart Utility/CartManager';
import logo from './../.../../../logo.svg';
import './Header.css'; // Moved styles to a CSS file for better maintainability

const Header = () => { // Default cart to an empty array
    const { user} = useAuth();
    const cart = useContext(CartContext); 

    return (
        <header className="header">
            <div className="logo">
                <Link to="/" className="logo-link">
                    <img src={logo} alt="Logo" className="logo-image" />
                </Link>
            </div>
            <nav className="navbar">
                <ul className="nav-links">
                    <li>
                        <Link to="/" className="nav-link">Home</Link>
                    </li>
                    <li>
                        <Link to="/cart" className="nav-link">Cart<span className="basket-count">{cart.items.length}</span></Link>
                    </li>
                    {user ? (<li>
                                <Link to="/account" className="nav-link">Account</Link>
                    </li>) : null}
                    {user ? (<li>
                                <Link to="/logout" className="nav-link" >Logout</Link>
                    </li>) : null}
                    {user ?  null : 
                            (<li>
                                <Link to="/login" className="nav-link" >Login/Register</Link>
                            </li>)}
    
                </ul>
            </nav>
        </header>
    );
};

export default Header; 